// extracted by mini-css-extract-plugin
export default {"root":"IconPicture_root__5DIgk"};